<div id="matProgressBar">
  @if (visible) {
    <mat-progress-bar color="accent" [mode]="mode" [bufferValue]="bufferValue" [value]="value"></mat-progress-bar>
  }
</div>
